import { suggestAnimationName, suggestedFrameNames } from "./suggest-frame.ts";
import { SHRINE } from "./type-names.ts";

/**
 * What a prop pulled from a pack the world does not list brings with it (ADR-129 decision 3.9), as the game's
 * rule for the index to ask: the frame names every object type the game registers would give the prop's states
 * and its transitions' strips, whatever type the builder later gives it. The rules are the ones the inspector's
 * Suggest uses (ADR-053 decision 2, ADR-058, ADR-096 decision 40), so a prop pulled with its states offers in
 * the state picker the frames Suggest would. A name no frame of the pack carries finds nothing and costs nothing.
 */

/**
 * The names of the frames a placed frame's states and transitions rest on, from its name and the names of its
 * tileset's prop frames.
 *
 * @param placed The name of the frame, as the catalogue lists it.
 * @param names The names of the prop frames of the placed frame's tileset, for the rules that pair by words.
 * @returns The names the game's types suggest, each once, never the placed frame's own.
 */
export function broughtWithNames(placed: string, names: readonly string[]): string[] {
  const pop = suggestAnimationName(SHRINE, "pop", placed, names);
  return [...new Set([...suggestedFrameNames(placed), ...(pop === undefined ? [] : [pop])])].filter((name) => name !== placed);
}
